import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShellService } from '../shell/shell.service';

/**
 * /dashboard. Inspectors get the inspector dashboard; administrators and staff the administrator
 * dashboard (mockup administrator/). The old dashboard, with its reports, stays at /dashboard-classic.
 */
@Component({
    selector: 'app-dashboard-home',
    template: `
        <app-inspector-dashboard *ngIf="isInspector"></app-inspector-dashboard>
        <app-admin-dashboard *ngIf="!isInspector"></app-admin-dashboard>
    `
})
export class DashboardHomeComponent implements OnInit, OnDestroy {
    isInspector = false;

    constructor(private shell: ShellService) { }

    ngOnInit() {
        this.isInspector = this.shell.user.user_level == 'inspector';
        if (this.isInspector) {
            // Deferred a tick: the top bar has already been checked in this change-detection pass.
            Promise.resolve().then(() => this.shell.setPageHeader({ greeting: true }));
        }
    }

    ngOnDestroy() {
        if (this.isInspector) {
            this.shell.setPageHeader(null);
        }
    }
}
